// @flow
import type { Action } from "../actions/types";
import {
  FETCH_FEEDBACK_FORM,
  FETCH_FEEDBACK_FORM_SUCCESS,
  FETCH_FEEDBACK_FORM_ERROR,
  SUBMIT_FEEDBACK,
  SUBMIT_FEEDBACK_SUCCESS,
  SUBMIT_FEEDBACK_ERROR
} from "../actions/types";

export type FeedbackState = {|
  fetched: boolean;
  feedbackList: null | {},
  selectedOrder: null | {},
  lastOrder: boolean,
  submittedFeedback: boolean,
  error: typeof Error | null,
|};

const initialState: FeedbackState = {
  fetched: false,
  feedbackList: null,
  selectedOrder: null,
  lastOrder: false,
  submittedFeedback: false,
  error: null,
};

export const feedbackReducer = (state: FeedbackState = initialState, action: Action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_FEEDBACK_FORM:
      return {
        ...state,
        fetched: false,
        feedbackList: [],
      }

    case FETCH_FEEDBACK_FORM_SUCCESS:
      return {
        ...state,
        fetched: true,
        feedbackList: payload,
        error: null,
      }

    case FETCH_FEEDBACK_FORM_ERROR:
      return {
        ...state,
        fetched: true,
        feedbackList: [],
        error: payload,
      }

    case SUBMIT_FEEDBACK:
      return {
        ...state,
        submittedFeedback: false,
      }

    case SUBMIT_FEEDBACK_SUCCESS:
      return {
        ...state,
        submittedFeedback: true,
        error: null,
      }

    case SUBMIT_FEEDBACK_ERROR:
      return {
        ...state,
        submittedFeedback: true,
        error: payload,
      }

    default:
      return state;
  }
}